import { render, staticRenderFns } from "./FormEmailInput.vue?vue&type=template&id=85c863c0&"
import script from "./FormEmailInput.vue?vue&type=script&lang=js&"
export * from "./FormEmailInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports